(function () {
  const block = {
    $blocks: document.querySelectorAll('.all_events'),
    init() {
      if (this.$blocks.length) {
        this.setUpListeners();
      }
    },

    setUpListeners() {
      this.$blocks
        .forEach($block => {
          const $pastEvents = $block.querySelector('.past_events');

          if ($pastEvents) {
            $pastEvents
              .querySelector('.load_more')
              .addEventListener('click', ({currentTarget}) => {
                $pastEvents.classList.add('expanded');
              });
          }
        });
    }
  };

  block.init();
})();

